import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Stack,
  TextField,
  Box,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Iconify } from "src/components";
import { useNavigate } from "react-router-dom";
import ConfirmDelete from "./ConfirmDelete";

export default function DeleteAccountDialog({
  open,
  onToggle,
  onAgree,
  loading = false,
  user,
}) {
  const is_mobile_view = useMediaQuery("(max-width:600px)");

  const navigate = useNavigate();
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);

  const handleClose = () => {
    if (!loading) {
      onToggle(false);
    }
  };

  const openDeleteConfirm = () => {
    setOpenConfirmDelete(true);
  };
  const closeDeleteConfirm = () => {
    setOpenConfirmDelete(false);
    handleClose();
  };

  const handleNavigate = () => {
    navigate("/support?openDrawer=true");
    handleClose();
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle sx={{ p: is_mobile_view ? "10px 16px" : "16px 24px" }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{ fontSize: is_mobile_view && "13px" }}
          >
            {user?.first_name} We're sorry to see you go!
            <IconButton size="small" onClick={handleClose}>
              <Iconify
                icon="ion-close"
                sx={{
                  height: "24px",
                  width: "24px",
                }}
              />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent
          sx={{ p: is_mobile_view ? "10px 16px" : "0 24px 20px" }}
        >
          <Stack spacing={1}>
            <Typography fontSize={is_mobile_view && "12px"}>
              Deleting your account will remove your personal information,
              workspaces, projects and tasks that you created. However, any
              comments, tasks, or other contributions in workspaces where you
              were invited will remain.
            </Typography>
            <Typography fontSize={is_mobile_view && "12px"}>
              If you need any assistance, please don't hesitate to
              <span
                style={{
                  fontWeight: 600,
                  color: "#00AB55",
                  padding: "0px 8px",
                }}
              >
                <Iconify fontSize="16px" icon="bx:support" marginBottom="2px" />{" "}
                CONTACT SUPPORT
              </span>
              Our team will reach out to you within next 24 hours.
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: is_mobile_view ? "end" : "space-between",
          }}
        >
          <div className={is_mobile_view ? "d-none" : "ms-2"}>
            <Button variant="text" color="primary" onClick={handleClose}>
              Cancel
            </Button>
          </div>
          <div className="d-flex">
            <Button
              size={is_mobile_view ? "small" : "medium"}
              variant="text"
              color="inherit"
              onClick={openDeleteConfirm}
            >
              Delete Account
            </Button>
            <Button
              size={is_mobile_view ? "small" : "medium"}
              variant="contained"
              onClick={handleNavigate}
              startIcon={<Iconify fontSize="16px" icon="bx:support" />}
              sx={{ ml: 1 }}
            >
              Contact Support
            </Button>
          </div>
        </DialogActions>
      </Dialog>
      {/* Confirm Delete Dialog  --------- */}
      <ConfirmDelete
        open={openConfirmDelete}
        onAgree={onAgree}
        onClose={closeDeleteConfirm}
        loading={loading}
        closeDeleteDialog={handleClose}
      />
    </>
  );
}

DeleteAccountDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onAgree: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};
